<template>
  <div>
    <b-navbar
      class="Header shadow"
      fixed="top"
      v-bind:class="{ 'is-close': closeSidebar}"
    >
      <div class="Header-PageTitle">{{pageTitle}}</div>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "Header",
  computed: {
    ...mapGetters([
      'closeSidebar',
      'pageTitle'
    ]),
  },
  mounted() {
      if(process.env.NODE_ENV !== 'development') {
            // cookie banner was here
      }

  },
}
</script>

<style scoped>
/* Lo stile fornito può essere aggiunto qui, se necessario */
</style>
